module.exports = __webpack_public_path__ + "Flag-784.6ab1227cbf8295d20ed9fc79f19f955b.svg";